export const getEnquiryId = fetch(
  "https://apiterm-reco.fynity.in/api/rec-enquiry",
  { method: "POST" },
)
  .then(res => res.json())
  .catch(() => ({}));

export const getAnswers = (enquiryId = "") =>
  fetch(
    `https://apiterm-reco.fynity.in/api/rec-user-data?enquiry_id=${enquiryId}`,
  )
    .then(res => res.json())
    .catch(() => ({}));

export const getRecommendationSummary = (enquiryId = "") =>
  fetch(
    `https://apiterm-reco.fynity.in/api/rec-plan-summary?enquiry_id=${enquiryId}`,
  )
    .then(res => res.json())
    .catch(() => ({}));

export const validatePincode = (pincode = "") =>
  fetch(`https://apiterm-reco.fynity.in/api/pincode?pincode=${pincode}`, {
    method: "POST",
  })
    .then(res => res.json())
    .catch(() => ({}));

export const incomeMultiplier = ({
  enquiryId,
  annual_income,
  age,
  sum_assured,
}) =>
  fetch(
    `https://apiterm-reco.fynity.in/api/income-multiplier?enquiry_id=${enquiryId}`,
    {
      method: "POST",
      body: JSON.stringify({ annual_income, age, sum_assured }),
      headers: {
        "content-type": "application/json",
      },
    },
  ).then(res => res.json());

export const termEnquiry = ({ enquiryId }) =>
  fetch(`https://healthapi.fynity.in/api/v1/enquiries`, {
    headers: {
      "Enquiry-Id": enquiryId,
    },
  }).then(res => res.json());
